import React from 'react';
import PropTypes from 'prop-types'; 
import {Image,Button} from 'react-bootstrap';

class MayLikeItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity:  0,
      show: this.props.show || true,
      max: 50,
      min: 0
    };
  }


  IncrementItem = () => {
    this.props.incrementItem(this.props.item);

  }
  DecreaseItem = () => {
    this.props.decreaseItem(this.props.item);
  }


	render() {
    	return (
    		<div className={"position-relative " + this.props.boxClass}>
                <Button onClick={this.props.onClickUpCellItem} className="btn btn-primary btn-sm position-absolute">ADD</Button>
                <Image src={this.props.image} 
                
                onClick={this.props.onClickUpCellItem}
                className={this.props.imageClass} alt={this.props.imageAlt} />
                {this.props.title?
	               <h6>{this.props.title}</h6>
	               :""
	            }
	            {this.props.price?
	              <small>{this.props.price}</small>
	               :""
	            }
            </div>
		);
	}
}


MayLikeItem.propTypes = {
  onAdd: PropTypes.func,
  image: PropTypes.string.isRequired,
  imageClass: PropTypes.string,
  imageAlt: PropTypes.string,
  boxClass: PropTypes.string,
  title: PropTypes.string,
  price: PropTypes.string,
};
MayLikeItem.defaultProps = {
  	imageAlt:'',
    image:'',
    imageClass:'',
    boxClass:'mall-category-item',
    title:'',
    price:'',
}

export default MayLikeItem;